import React, { useState, useEffect } from 'react';
import {
  Table, Input, DatePicker, Button, Form, Row, Col,
  Select, Pagination, Card, Modal, Typography
} from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import axiosInstance from '../../utils/axiosInstance';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Option } = Select;

const GalidisawerDeclareResults = () => {
  // ✅ 1. Modal Hook (Ye line sabse jaruri hai delete modal show karne ke liye)
  const [modal, contextHolder] = Modal.useModal();
  
  const [filters, setFilters] = useState({
    date: dayjs(),
    game: '',
    open_time: '',
    declaredDigit: ''
  });
  const [data, setData] = useState([]);
  const [winnersData, setWinnersData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5 });
  const [searchText, setSearchText] = useState('');
  const [gameOptions, setGameOptions] = useState([]);
  
  const [isWinnerModalOpen, setIsWinnerModalOpen] = useState(false);
  const [editingWinner, setEditingWinner] = useState(null);
  const [winnerForm] = Form.useForm();

  const getOpenTimeOptions = () => {
    if (filters.game) {
      const selectedGame = gameOptions.find(option => option._id === filters.game);
      return selectedGame ? [moment(selectedGame.open_time, "hh:mm:ssA").format("hh:mm A")] : [];
    }
    return [...new Set(
      gameOptions.map(option =>
        moment(option.open_time, "hh:mm:ssA").format("hh:mm A")
      )
    )];
  };

  const fetchDeclareResults = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const res = await axiosInstance.get('/api/JackpotDeclareResult/getResult', {
        headers: { 'Authorization': `Bearer ${accessToken}` }
      });
      setData(res.data.results);
    } catch (err) {
      console.error("Error fetching results:", err);
      // toast.error("Failed to load results"); // Optional
    }
  };

  useEffect(() => {
    fetchDeclareResults();
    const accessToken = localStorage.getItem("accessToken");
    axiosInstance.get('/api/jackpotMarket/getAllMarket', {
      headers: { 'Authorization': `Bearer ${accessToken}` }
    })
      .then(res => setGameOptions(res.data.data || []))
      .catch(() => toast.error("Failed to fetch games"));
  }, []);

  // ✅ 2. FIX: Delete Function using Hook
  const handleDeleteDeclareResult = (record) => {
    // Check if ID exists
    if (!record._id) {
      toast.error("Error: Record ID missing");
      return;
    }

    modal.confirm({
      title: 'Are you sure you want to delete this result?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone and will revert winning amounts from wallets.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'No',
      async onOk() {
        try {
          const accessToken = localStorage.getItem("accessToken");
          await axiosInstance.delete(`/api/JackpotDeclareResult/delete/${record._id}`, {
            headers: { 'Authorization': `Bearer ${accessToken}` }
          });
          toast.success("Deleted successfully 🗑️");
          fetchDeclareResults(); // Refresh table
        } catch (err) {
          console.error("Delete Error:", err);
          toast.error(err.response?.data?.error || "Failed to delete result ❌");
        }
      },
      onCancel() {
        console.log('Delete cancelled');
      },
    });
  };

  const handleFilterChange = (value, key) => {
    setFilters(prev => ({ ...prev, [key]: value, ...(key === 'game' && { open_time: '' }) }));
  };

  const handleShowWinnersClick = async () => {
    try {
      const selectedGame = gameOptions.find(g => g._id === filters.game);
      const gameValue = selectedGame
        ? `${selectedGame.game_name} [ ${moment(selectedGame.open_time, "hh:mm:ssA").format("hh:mm A")} ]`
        : '';

      const body = {
        date: filters.date.format("DD-MM-YYYY"),
        game: gameValue,
        digit: filters.declaredDigit
      };

      const token = localStorage.getItem("accessToken");
      const res = await axiosInstance.post("/api/jackpotWinners/showwinners", body, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (res.data.winners && res.data.winners.length > 0) {
        toast.success(`Found ${res.data.winners.length} Winners! 🎉`);
      } else {
        toast.info("No winners found for this criteria.");
      }

      setWinnersData(res.data.winners);
    } catch (err) {
      toast.error("Failed to fetch winners");
    }
  };

  const handleDeclareResultClick = async () => {
    try {
      const selectedGame = gameOptions.find(g => g._id === filters.game);
      const gameValue = selectedGame
        ? `${selectedGame.game_name} ${moment(selectedGame.open_time, "hh:mm:ssA").format("hh:mm A")}`
        : '';

      const body = {
        marketName: "Jackpot",
        date: filters.date.format("DD-MM-YYYY"),
        game: gameValue,
        open_time: filters.open_time,
        declaredDigit: filters.declaredDigit
      };

      const token = localStorage.getItem("accessToken");
      await axiosInstance.post("/api/JackpotDeclareResult/declare", body, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      toast.success("Result declared successfully! ✅");
      fetchDeclareResults();
    } catch (err) {
      const errMsg = err.response?.data?.error || "Failed to declare result";
      toast.error(errMsg);
    }
  };

  const handleEditWinner = (record) => {
    setEditingWinner(record);
    winnerForm.setFieldsValue({
      userName: record.userName,
      points: record.bidPoints,
      winningPoints: record.winningPoints,
      digit: record.digit
    });
    setIsWinnerModalOpen(true);
  };

  const handleUpdateWinner = async () => {
    try {
      const values = await winnerForm.validateFields();
      const payload = {
        points: values.points,
        digit: values.digit
      };

      const accessToken = localStorage.getItem("accessToken");
      await axiosInstance.put(
        `/api/jackpotBid/updateBid/${editingWinner._id}`,
        payload,
        {
          headers: { 'Authorization': `Bearer ${accessToken}` }
        }
      );

      toast.success("Bid updated successfully ✅");
      setIsWinnerModalOpen(false);
      setEditingWinner(null);
      handleShowWinnersClick();
    } catch (err) {
      console.error("Error updating bid:", err);
      toast.error(err.response?.data?.message || "Failed to update bid");
    }
  };

  const columns = [
    { title: '#', render: (_, __, index) => index + 1 },
    { title: 'Game Name', dataIndex: 'gameName' },
    { title: 'Result Date', dataIndex: 'date', render: text => moment(text).format('DD-MM-YYYY') },
    { title: 'Winning Digit', dataIndex: 'declaredDigit' },
    {
      title: 'Action',
      render: (_, record) => (
        <Button danger onClick={() => handleDeleteDeclareResult(record)}>Delete</Button>
      )
    }
  ];

  const winnersColumns = [
    { title: 'User Name', dataIndex: 'userName' },
    { title: 'Bid Points', dataIndex: 'bidPoints' },
    { title: 'Winning Points', dataIndex: 'winningPoints' },
    { title: 'Market Name', dataIndex: 'marketName' },
    { title: 'Game Name', dataIndex: 'gameName' },
    { title: 'Digit', dataIndex: 'digit' },
    {
      title: 'Date',
      dataIndex: 'date',
      render: text => text ? moment(text).format('YYYY-MM-DD') : ''
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button type="primary" onClick={() => handleEditWinner(record)}>
          Edit
        </Button>
      )
    }
  ];

  return (
    <div style={{ padding: 20 }}>
      {/* ✅ 3. ContextHolder (Iske bina Delete Popup nahi aayega) */}
      {contextHolder}
      <ToastContainer position="top-right" autoClose={3000} />

      <h1 style={{ textAlign: 'center' }}>Jackpot Declare Results</h1>

      <Card style={{ marginBottom: 20 }}>
        <Form layout="vertical">
          <Row gutter={[16, 16]}>
            <Col md={4}>
              <Form.Item label="Date">
                <DatePicker
                  value={filters.date}
                  onChange={date => handleFilterChange(date, 'date')}
                  format="DD-MM-YYYY"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>

            <Col md={6}>
              <Form.Item label="Game">
                <Select
                  showSearch
                  value={filters.game}
                  placeholder="Select Game"
                  onChange={value => handleFilterChange(value, 'game')}
                  style={{ width: '100%' }}
                >
                  {gameOptions.map(opt => (
                    <Option key={opt._id} value={opt._id}>
                      {`${opt.game_name} ${moment(opt.open_time, "hh:mm:ssA").format("hh:mm A")}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col md={4}>
              <Form.Item label="Open Time">
                <Select
                  showSearch
                  value={filters.open_time}
                  placeholder="Open Time"
                  onChange={value => handleFilterChange(value, 'open_time')}
                  style={{ width: '100%' }}
                >
                  {getOpenTimeOptions().map(time => (
                    <Option key={time} value={time}>{time}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col md={4}>
              <Form.Item label="Digit">
                <Input
                  value={filters.declaredDigit}
                  onChange={e => handleFilterChange(e.target.value, 'declaredDigit')}
                  maxLength={2}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>

      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <Button
          onClick={handleShowWinnersClick}
          style={{ marginRight: 8 }}
          disabled={!filters.declaredDigit}
        >
          Show Winners
        </Button>
        <Button type="primary" onClick={handleDeclareResultClick}>Declare Result</Button>
      </div>

      <Card title="Winners List" style={{ marginBottom: 20 }}>
        <Table
          columns={winnersColumns}
          dataSource={winnersData}
          rowKey="_id"
          pagination={false}
          scroll={{ x: '100%' }}
        />
      </Card>

      <Card>
        <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
          <Col>
            Show
            <Select
              defaultValue={pagination.pageSize}
              style={{ width: 70, margin: '0 8px' }}
              onChange={value => setPagination(prev => ({ ...prev, pageSize: value }))}
            >
              {[5, 10, 20].map(size => (
                <Option key={size} value={size}>{size}</Option>
              ))}
            </Select>
            entries
          </Col>
          <Col>
            <Input
              placeholder="Search by Game Name"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </Col>
        </Row>

        <Table
          columns={columns}
          dataSource={data
            .filter(item => item.gameName?.toLowerCase().includes(searchText.toLowerCase()))
            .slice((pagination.current - 1) * pagination.pageSize, pagination.current * pagination.pageSize)}
          rowKey="_id"
          pagination={false}
          scroll={{ x: '100%' }}
        />

        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={data.length}
          onChange={page => setPagination(prev => ({ ...prev, current: page }))}
          style={{ marginTop: 16, textAlign: 'right' }}
        />
      </Card>

      {/* Winner Edit Modal */}
      <Modal
        title="Edit Winner"
        open={isWinnerModalOpen}
        onOk={handleUpdateWinner}
        onCancel={() => {
          setIsWinnerModalOpen(false);
          setEditingWinner(null);
        }}
      >
        <Form form={winnerForm} layout="vertical">
          <Form.Item
            name="userName"
            label="User Name"
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            name="points"
            label="Bid Points"
            rules={[{ required: true, message: 'Please enter bid points' }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="winningPoints"
            label="Winning Points"
          >
            <Input type="number" disabled />
          </Form.Item>
          <Form.Item
            name="digit"
            label="Digit"
            rules={[{ required: true, message: 'Please enter digit' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default GalidisawerDeclareResults;